module.exports = __webpack_public_path__ + "static/media/gerbrock.76914092.png";